var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPraiseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9.333,
    r: 5.333,
    stroke: "#AA90F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9.333,
    r: 2.667,
    stroke: "#AA90F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.623 3.41l.434.248-.434-.248zM5.1 5.42l-1.29-2.257-.868.496 1.29 2.257.868-.496zM3.833 3.245V1.667h-1v1.578h1zm-.166-1.412h8.666v-1H3.668v1zm8.5-.166v1.578h1V1.667h-1zm.022 1.495l-1.29 2.257.869.496 1.289-2.257-.868-.496zm-.022.083c0-.03.007-.058.022-.083l.868.496a.833.833 0 00.11-.413h-1zm.167-1.412a.167.167 0 01-.167-.166h1a.833.833 0 00-.833-.834v1zm-8.5-.166a.167.167 0 01-.167.166v-1a.833.833 0 00-.833.834h1zm-.022 1.495a.167.167 0 01.022.083h-1c0 .145.037.287.11.413l.868-.496z",
    fill: "#AA90F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1v3.333M10 1v3.333",
    stroke: "#AA90F4"
  })));
}
export default __webpack_public_path__ + "static/praise-icon.9df7a3e0.svg";
export { SvgPraiseIcon as ReactComponent };